import { Quote, Star } from "lucide-react";
import { TESTIMONIALS, IMAGES, BUSINESS } from "../lib/data";

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="section-pad bg-[#FAFAF9]"
    >
      <div className="msc-container">
        <div className="grid lg:grid-cols-12 gap-10 items-start">
          {/* Founder card */}
          <div className="lg:col-span-5">
            <div className="card-base p-6 sm:p-8 relative overflow-hidden flex flex-col h-full">
              <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#F59E0B]/15" />
              <div className="relative flex-1">
                <span className="badge-trust">Hamare Bani</span>
                <h2 className="mt-3 font-display font-black text-2xl sm:text-3xl text-[#1F2937] leading-tight">
                  Janab {BUSINESS.founder} Saheb
                </h2>
                <p className="mt-2 text-sm font-semibold text-[#D97706] uppercase tracking-wider">
                  Visionary Founder · Established in 1971
                </p>
                <div className="mt-3 bg-white/60 p-3 rounded-lg border border-gray-100">
                  <div className="text-[10px] font-bold text-[#4B5563] uppercase tracking-wider opacity-80 mb-1">
                    Currently Operated By:
                  </div> 
                  <div className="text-[#1E3A8A] font-black text-sm sm:text-base leading-snug">
                    Janab {BUSINESS.operatedBy}
                  </div>
                </div>

                <div className="mt-6">
                  <p className="text-base text-[#4B5563] leading-relaxed italic border-l-4 border-[#F59E0B] pl-4">
                    “Ek chhote se dukaandar se shuru hua yeh safar, aaj Bhiwandi ka bharosa ban chuka hai. 1971 mein jo neev rakhi gayi thi, wo aaj bhi imandari, asli daam aur customer ki khidmat par khadi hai. Hamari pehchaan hamara kaam hai.”
                  </p>
                </div>
              </div>
              <div className="mt-8 pt-4 border-t border-gray-100 flex items-center justify-between">
                 <div className="text-xs font-bold text-[#1E3A8A] uppercase tracking-wider">
                    54+ Years of Legacy
                 </div>
              </div>
            </div>
          </div>

          {/* Reviews */}
          <div className="lg:col-span-7">
            <span className="badge-trust">Customers Bolte Hain</span>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl text-[#1F2937] leading-tight">
              <span className="text-[#1E3A8A]">Bhiwandi</span> ka Bharosa
            </h2>

            <div className="mt-7 space-y-4">
              {TESTIMONIALS.map((t, i) => (
                <div
                  key={t.name}
                  data-testid={`testimonial-${i}`}
                  className="card-base p-5 sm:p-6 flex gap-4"
                >
                  <Quote className="w-6 h-6 text-[#F59E0B] shrink-0" />
                  <div>
                    <div className="flex items-center gap-1 mb-1.5" aria-label="5 star rating">
                      {[...Array(5)].map((_, k) => (
                        <Star
                          key={k}
                          className="w-4 h-4 fill-[#F59E0B] text-[#F59E0B]"
                        />
                      ))}
                    </div>
                    <p className="text-[#1F2937] text-sm sm:text-base leading-relaxed">
                      “{t.text}”
                    </p>
                    <div className="mt-3 text-sm">
                      <span className="font-display font-bold text-[#1F2937]">
                        {t.name}
                      </span>
                      <span className="text-[#4B5563]"> · {t.place}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
